import {companiesService} from "@/_services";
import router from "@/router";

export default {
  getAll({dispatch, commit}, {page, sort, search}) {
    companiesService.getAll(page, sort, search)
      .then(
        companies => {
          commit("setCompaniesData", companies)
          return Promise.resolve(companies);
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  showCompany({dispatch, commit}, {company}) {
    return companiesService.showCompany(company)
      .then(
        companies => {
          commit("setCurrentCompany", companies);
          return Promise.resolve(companies);
        },
        error => {
          dispatch("alert/error", error, { root: true });
        }
      )
  },
  // Vuelve a pedir el detalle de la carpeta activa (owner_available_credits, logo, etc.).
  // Lo llaman las acciones de documentos tras consumir/liberar firmas para que el
  // contador de la barra lateral no quede desactualizado.
  refreshCurrentCompany({dispatch, rootState}) {
    const me = rootState.account && rootState.account.user ? rootState.account.user.me : null;
    const selectedCompany = me ? me.selected_company : null;
    if (!selectedCompany || !selectedCompany.id) {
      return Promise.resolve(null);
    }
    return dispatch("showCompany", { company: selectedCompany.id });
  },
  createCompany({dispatch, commit}, {company, aclChangeRole}) {
    dispatch("alert/clear", {}, {root:true});
    return companiesService.createCompany(company)
      .then(
        () => {
          dispatch("companies/getAll", {page: 0}, {root: true});
          return dispatch("account/me", {aclChangeRole}, {root:true}).then(
            () => {
              dispatch("alert/success", "Se agregó la Carpeta de trabajo con éxito", {root:true});
              return Promise.resolve();
            }
          )
        },
        error => {
          dispatch("alert/error", error, {root:true});
          return Promise.reject(error);
        }
      )
  },
  updateCompany({dispatch, commit}, {company, aclChangeRole}) {
    dispatch("alert/clear", {}, {root:true});
    return companiesService.updateCompany(company)
      .then(
        () => {
          dispatch("companies/getAll", {page: 0}, {root: true});
          dispatch("account/me", {aclChangeRole}, {root:true});
          dispatch("alert/success", "Se actualizó la Carpeta de trabajo con éxito", {root:true});
          return Promise.resolve();
        },
        error => {
          dispatch("alert/error", error, {root:true});
          return Promise.reject(error);
        }
      )
  },
}
